module.exports = __webpack_public_path__ + "img/bg-image-9.9b821502.jpg";